import React from "react"
import { Icon, type IconName } from "../icon"
import { type NoteVariant, useNoteContext } from "./note-context"

const defaultIconNames: Record<NoteVariant, IconName> = {
  info: "lightbulb",
  upsell: "information-circle",
  success: "check-circle",
  warning: "alert-circle",
  error: "alert-triangle"
}

export type NoteIconProps = {
  name?: IconName
}

export function NoteIcon({ name }: NoteIconProps) {
  const { variant } = useNoteContext()

  return (
    <div
      className="[grid-area:icon] flex items-center justify-center"
      data-slot="note-icon"
    >
      <Icon name={name ?? defaultIconNames[variant]} />
    </div>
  )
}
